import {Stack, styled} from '@mui/material';

const StyledStack = styled(Stack)`
	background-color: ${({theme}) => theme.palette.background.paper};
	width: 100%;
	border-radius: 8px;
	padding: 16px;
	gap: 8px;
`;

export {StyledStack};
